// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCYFy7itV3wguw88uBDxfDN_dbfX2Yw2VQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "sexcoin-235c2.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "sexcoin-235c2",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "sexcoin-235c2.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "254444948532",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:254444948532:web:27e09bd0947af94141ce61"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export default app;